export default __webpack_public_path__ + "images/30f788fe0a74a7f1d33c8e9207eed765-agnostic_small.webp";